var _classCallCheck = require("C:\\Users\\nisik\\Documents\\Projects\\3dcgGate\\cggate-project\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\nisik\\Documents\\Projects\\3dcgGate\\cggate-project\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\nisik\\Documents\\Projects\\3dcgGate\\cggate-project\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\nisik\\Documents\\Projects\\3dcgGate\\cggate-project\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _inherits = require("C:\\Users\\nisik\\Documents\\Projects\\3dcgGate\\cggate-project\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

var _slicedToArray = require("C:\\Users\\nisik\\Documents\\Projects\\3dcgGate\\cggate-project\\frontend\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/slicedToArray");

var _require = require('stream'),
    Transform = _require.Transform;

var genobj = require('generate-object-property');

var genfun = require('generate-function');

var bufferFrom = require('buffer-from');

var bufferAlloc = require('buffer-alloc');

var _bufferFrom = bufferFrom('\r'),
    _bufferFrom2 = _slicedToArray(_bufferFrom, 1),
    cr = _bufferFrom2[0];

var _bufferFrom3 = bufferFrom('\n'),
    _bufferFrom4 = _slicedToArray(_bufferFrom3, 1),
    nl = _bufferFrom4[0];

var defaults = {
  escape: '"',
  headers: null,
  mapHeaders: function mapHeaders(_ref) {
    var header = _ref.header;
    return header;
  },
  mapValues: function mapValues(_ref2) {
    var value = _ref2.value;
    return value;
  },
  newline: '\n',
  quote: '"',
  raw: false,
  separator: ',',
  skipComments: false,
  skipLines: null,
  maxRowBytes: Number.MAX_SAFE_INTEGER,
  strict: false
};

var CsvParser =
/*#__PURE__*/
function (_Transform) {
  "use strict";

  _inherits(CsvParser, _Transform);

  function CsvParser() {
    var _this;

    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, CsvParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CsvParser).call(this, {
      objectMode: true,
      highWaterMark: 16
    }));
    if (Array.isArray(opts)) opts = {
      headers: opts
    };
    var options = Object.assign({}, defaults, opts);
    _this.customNewline = options.newline !== defaults.newline;

    for (var _i = 0, _Object$keys = Object.keys(options); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];

      if (['newline', 'quote', 'separator'].includes(key)) {
        var _bufferFrom5 = bufferFrom(options[key]);

        var _bufferFrom6 = _slicedToArray(_bufferFrom5, 1);

        options[key] = _bufferFrom6[0];
      } // legacy codebase support


      _this[key] = options[key];
    } // if escape is not defined on the passed options, use the end value of quote


    _this.escape = (opts || {}).escape ? bufferFrom(options.escape)[0] : options.quote;

    if (_this.headers === false) {
      // enforce, as the column length check will fail if headers:false
      _this.strict = false;
    }

    _this._prev = null;
    _this._prevEnd = 0;
    _this._first = true;
    _this._quoted = false;
    _this._escaped = false;
    _this._empty = _this._raw ? bufferAlloc(0) : '';
    _this._Row = null;
    _this._currentRowBytes = 0;
    _this._line = 0;

    if (_this.headers || _this.headers === false) {
      _this._first = false;

      _this._compile();
    }

    return _this;
  }

  _createClass(CsvParser, [{
    key: "_compile",
    value: function _compile() {
      var _this2 = this;

      if (this._Row) return;
      var Row = genfun()('function Row (cells) {');

      if (this.headers) {
        this.headers.forEach(function (header, index) {
          var newHeader = _this2.mapHeaders({
            header: header,
            index: index
          });

          if (newHeader) {
            Row('%s = cells[%d]', genobj('this', newHeader), index);
          }
        });
      } else {
        // -> false
        Row("\n        for (const [index, value] of cells.entries()) {\n          this[index] = value\n        }\n      ");
      }

      Row('}');
      this._Row = Row.toFunction();
      Object.defineProperty(this._Row.prototype, 'headers', {
        enumerable: false,
        value: this.headers
      });
    }
  }, {
    key: "_emit",
    value: function _emit(Row, cells) {
      this.push(new Row(cells));
    }
  }, {
    key: "_flush",
    value: function _flush(cb) {
      if (this._escaped || !this._prev) return cb();

      this._online(this._prev, this._prevEnd, this._prev.length + 1); // plus since online -1s


      cb();
    }
  }, {
    key: "_oncell",
    value: function _oncell(buf, start, end) {
      // remove quotes from quoted cells
      if (buf[start] === this.quote && buf[end - 1] === this.quote) {
        start++;
        end--;
      }

      var y = start;

      for (var i = start; i < end; i++) {
        // check for escape characters and skip them
        if (buf[i] === this.escape && i + 1 < end && buf[i + 1] === this.quote) i++;
        if (y !== i) buf[y] = buf[i];
        y++;
      }

      var value = this._onvalue(buf, start, y);

      return value;
    }
  }, {
    key: "_online",
    value: function _online(buf, start, end) {
      var _this3 = this;

      end--; // trim newline

      if (!this.customNewline && buf.length && buf[end - 1] === cr) end--;
      var comma = this.separator;
      var cells = [];
      var isQuoted = false;
      var offset = start;
      var skipComments = this.skipComments;

      if (skipComments) {
        var _char = typeof skipComments === 'string' ? skipComments : '#';

        if (buf[start] === bufferFrom(_char)[0]) {
          return;
        }
      }

      var mapValue = function mapValue(value) {
        if (_this3._first) {
          return value;
        }

        var index = cells.length;
        var header = _this3.headers[index];
        return _this3.mapValues({
          header: header,
          index: index,
          value: value
        });
      };

      for (var i = start; i < end; i++) {
        var isStartingQuote = !isQuoted && buf[i] === this.quote;
        var isEndingQuote = isQuoted && buf[i] === this.quote && i + 1 <= end && buf[i + 1] === comma;
        var isEscape = isQuoted && buf[i] === this.escape && i + 1 < end && buf[i + 1] === this.quote;

        if (isStartingQuote || isEndingQuote) {
          isQuoted = !isQuoted;
          continue;
        } else if (isEscape) {
          i++;
          continue;
        }

        if (buf[i] === comma && !isQuoted) {
          var value = this._oncell(buf, offset, i);

          value = mapValue(value);
          cells.push(value);
          offset = i + 1;
        }
      }

      if (offset < end) {
        var _value = this._oncell(buf, offset, end);

        _value = mapValue(_value);
        cells.push(_value);
      }

      if (buf[end - 1] === comma) {
        cells.push(mapValue(this._empty));
      }

      var skip = this.skipLines && this.skipLines > this._line;
      this._line++;

      if (this._first && !skip) {
        this._first = false;
        this.headers = cells;

        this._compile(cells);

        this.emit('headers', this.headers);
        return;
      }

      if (this.strict && cells.length !== this.headers.length) {
        var e = new RangeError('Row length does not match headers');
        this.emit('error', e);
      } else {
        if (!skip) this._emit(this._Row, cells);
      }
    }
  }, {
    key: "_onvalue",
    value: function _onvalue(buf, start, end) {
      if (this._raw) return buf.slice(start, end);
      return buf.toString('utf-8', start, end);
    }
  }, {
    key: "_transform",
    value: function _transform(data, enc, cb) {
      if (typeof data === 'string') data = bufferFrom(data);
      var start = 0;
      var buf = data;

      if (this._prev) {
        start = this._prev.length;
        buf = Buffer.concat([this._prev, data]);
        this._prev = null;
      }

      var bufLen = buf.length;

      for (var i = start; i < bufLen; i++) {
        var chr = buf[i];
        var nextChr = i + 1 < bufLen ? buf[i + 1] : null;
        this._currentRowBytes++;

        if (this._currentRowBytes > this.maxRowBytes) {
          return cb(new Error('Row exceeds the maximum size'));
        }

        if (!this._escaped && chr === this.escape && nextChr === this.quote && i !== start) {
          this._escaped = true;
          continue;
        } else if (chr === this.quote) {
          if (this._escaped) {
            this._escaped = false; // non-escaped quote (quoting the cell)
          } else {
            this._quoted = !this._quoted;
          }

          continue;
        }

        if (!this._quoted) {
          if (this._first && !this.customNewline) {
            if (chr === nl) {
              this.newline = nl;
            } else if (chr === cr) {
              if (nextChr !== nl) {
                this.newline = cr;
              }
            }
          }

          if (chr === this.newline) {
            this._online(buf, this._prevEnd, i + 1);

            this._prevEnd = i + 1;
            this._currentRowBytes = 0;
          }
        }
      }

      if (this._prevEnd === bufLen) {
        this._prevEnd = 0;
        return cb();
      }

      if (bufLen - this._prevEnd < data.length) {
        this._prev = data;
        this._prevEnd -= bufLen - data.length;
        return cb();
      }

      this._prev = buf;
      cb();
    }
  }]);

  return CsvParser;
}(Transform);

module.exports = function (opts) {
  return new CsvParser(opts);
};